import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
    Segment,
    Form,
    Button,
    Grid,
    Header,
    Dropdown,
    Card
} from "semantic-ui-react";
import {
    // incrementCounter,
    // decrementCounter,
    questionInput
} from "./testActions";
// import { openModal } from "../../features/modals/modalActions";
import {
    composeValidators,
    combineValidators,
    isRequired,
    hasLengthGreaterThan
} from "revalidate";

import TextInput from "../../util/common/TextInput";
import CustomTextArea from "../../util/common/TextArea";
import SelectInput from "../../util/common/SelectInput";
import moment from "moment";
import { category, categoryDivision, subDivision } from "./Category";
import firebase from "../../config/firebase";
import { toastr } from "react-redux-toastr";
import PreviewModal from "./PreviewModal";

const selector = formValueSelector("inputForm");

const mapState = state => {
    const auth = state.firebase.auth;
    const categoryName = selector(state, "category");
    const categoryDiv = selector(state, "categoryDiv");
    const categorySubDivision = selector(state, "categorySubDiv");
    const question = selector(state, "question");
    const option1 = selector(state, "option1");
    const option2 = selector(state, "option2");
    const option3 = selector(state, "option3");
    const option4 = selector(state, "option4");
    const answer = selector(state, "answer");
    const reference = selector(state, "ref");
    const id = selector(state, "id");
    return {
        auth,
        categoryName,
        categoryDiv,
        categorySubDivision,
        question,
        option1,
        option2,
        option3,
        option4,
        answer,
        reference,
        id
    };
};

const actions = {
    questionInput
    // createNewDocument
    // openModal
};

const validate = combineValidators({
    category: isRequired({ message: "Please provide a category" }),
    categoryDiv: isRequired({ message: "Please provide a category division" }),
    categorySubDiv: isRequired({
        message: "Please provide a category sub division"
    }),
    question: composeValidators(
        isRequired({ message: "Please enter the question" }),
        hasLengthGreaterThan(3)({
            message: "Question needs to be at least 3 characters"
        })
    )(),
    option1: isRequired("Please provide option1"),
    option2: isRequired("Please provide option2"),
    option3: isRequired("Please provide option3"),
    option4: isRequired("Please provide option4"),
    answer: isRequired("Please provide an answer"),
    ref: isRequired("Please provide a ref")
});

class ExperiemntPage extends Component {
    state = {
        validate: false,
        preview: false,
        submitReady: false,
        showEntryCategory: "",
        fetchEntries: null,
        selectedIndex: 0,
        alreadyFetchd: false,
        loading: false
    };

    // preview = false;
    // validate = false;
    // submitReady = false;

    viewQuestions = () => {
        //let results = this.props.viewQuestions();
        console.log("Question array ", this.props.questions);
    };

    goBack = () => {
        this.props.history.push("/category");
    };

    showData = () => {
        // this.getData().then(result => {
        //     console.log("DB Data ", result);
        // });
        this.getData();
    };

    shuffle = o => {
        for (
            var j, x, i = o.length;
            i;
            j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
        );
        return o;
    };

    randomReset = () => {
        this.randomResetFunc();
    };

    async randomResetFunc() {
        var numbers = [];
        for (let i = 1; i <= 35; i++) {
            numbers.push(i);
        }
        var random = this.shuffle(numbers);
        console.log("MY random number ", random);
        let firstCollectionQuerySnap = await firebase
            .firestore()
            .collection("Bangla")
            .get();
        let batch = await firebase.firestore().batch();
        console.log("for batch collection ", firstCollectionQuerySnap.docs);
        for (let i = 0; i < firstCollectionQuerySnap.docs.length; i++) {
            try {
                let firstCollectionDocRef = await firebase
                    .firestore()
                    .collection("Bangla")
                    .doc(firstCollectionQuerySnap.docs[i].id);
                await batch.update(firstCollectionDocRef, {
                    random: random[i]
                });
            } catch (error) {
                console.log("Found Error", error.message);
            }
        }
        try {
            await batch.commit();
        } catch (error) {
            console.log("Found Error in commit", error.message);
        }
    }

    async getData() {
        //generate a random value
        var numbers = [];
        for (let i = 1; i <= 35; i++) {
            numbers.push(i);
        }
        var random = this.shuffle(numbers);
        console.log("MY random number ", random);
        //fetch data
        let count = 3;

        await firebase
            .firestore()
            .collection("Bangla")
            .where("random", ">", random[0])
            .orderBy("random")
            .limit(2)
            .get()
            .then(function(querySnapshot) {
                console.log("query snapshot count ", querySnapshot.docs.length);
                if (querySnapshot.docs.length < 2) {
                    count = querySnapshot.docs.length;
                }
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });

        if (count < 3) {
            await firebase
                .firestore()
                .collection("Bangla")
                .where("random", "<=", random[0])
                .orderBy("random")
                .limit(2 - count)
                .get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots

                        console.log(doc.id, " => ", doc.data());
                    });
                })
                .catch(function(error) {
                    console.log("Error getting documents: ", error);
                });
        }
    }

    async createTestDocuments() {
        console.log("function called");
        // return async (dispatch, getState, { getFirestore }) => {
        //     const firestore = getFirestore();
        //     const user = firestore.auth().currentUser;
        //     const photoURL = getState().firebase.profile.photoURL;
        //     console.log("User profile id ", user);
        try {
            let querySnap = await firebase
                .firestore()
                .collection("Bangla")
                .orderBy("random")
                .get();
            let data = [];
            for (let i = 0; i < 30; i++) {
                data.push(querySnap.docs[i].data());
            }
            // await firebase
            //     .firestore()
            //     .collection("CategoryTests")
            //     .doc("CategoryTest12")
            //     .update({
            //         createdAt: moment(Date.now()).toDate()
            //     });
            await firebase
                .firestore()
                .collection("CategoryTests")
                .doc("CategoryTest1")
                .set({
                    data: data,
                    attendees: {
                        // [user.uid]: {
                        //     photoURL: photoURL || "/assets/user.png",
                        //     displayName: user.displayName
                        // }
                    },
                    rating: {},
                    subject: "Category1",
                    testCollection: "CategoryTests",
                    testId: "CategoryTest1",
                    avgScore: 0,
                    topScore: 0,
                    avgRating: 0,
                    createdAt: moment(Date.now()).toDate()
                });
            toastr.success("Success", "Question added to database");
        } catch (error) {
            console.log("Error message :", error.message);
            toastr.error("Opps!", "Something went wrong");
        }
        // };
    }

    onFormSubmit = async values => {
        const { auth, id } = this.props;
        console.log("auth ", auth);
        console.log("id ", id);

        if (id) {
            console.log("id found");
            console.log(
                "collection",
                this.state.fetchEntries[this.state.selectedIndex].data.category
            );
            console.log(
                "doc",
                this.state.fetchEntries[this.state.selectedIndex].id
            );
            console.log(
                "data",
                this.state.fetchEntries[this.state.selectedIndex].data
            );
            // values.author = auth.email;
            // values.date = moment(Date.now()).toDate();
            try {
                await firebase
                    .firestore()
                    .collection(
                        this.state.fetchEntries[this.state.selectedIndex].data
                            .category
                    )
                    .doc(this.state.fetchEntries[this.state.selectedIndex].id)
                    .set({
                        data: this.state.fetchEntries[this.state.selectedIndex]
                            .data
                    });

                this.setState({
                    submitReady: false,
                    validate: false,
                    preview: false
                });
                toastr.success("Success", "Question updated");
                this.props.reset();
            } catch (error) {
                console.log("Opps!, Something is wrong", error);
            }
        } else {
            console.log("id not found");
            values.author = auth.email;
            values.date = moment(Date.now()).toDate();
            // if (values.category === "বাংলা ভাষা ও সাহিত্য") {
            // await firebase
            //     .firestore()
            //     .collection(values.category)
            //     .doc(cuid())
            //     .set({
            //         values
            //     });
            console.log("values ", values);

            try {
                await firebase
                    .firestore()
                    .collection(values.category)
                    .add({
                        data: values
                    })
                    .then(function(docRef) {
                        console.log("Document written with ID: ", docRef.id);
                    })
                    .catch(function(error) {
                        console.error("Error adding document: ", error);
                    });
                this.setState({
                    submitReady: false,
                    validate: false,
                    preview: false
                });
                toastr.success("Success", "Question added to database");
                this.props.reset();
            } catch (error) {
                console.log("error", error);
                toastr.error("Opps!", "Something went wrong");
            }
        }

        //   }
        // await firebase.firestore().collection(values.)
    };

    qusValidate = (option1, option2, option3, option4, answer) => () => {
        let options = [];
        let matchFound = false;
        options.push(option1);
        options.push(option2);
        options.push(option3);
        options.push(option4);
        if (
            answer === option1 ||
            answer === option2 ||
            answer === option3 ||
            answer === option4
        ) {
            for (let i = 0; i < options.length; i++) {
                for (let j = 0; j < options.length; j++) {
                    // console.log(options[i], options[j]);
                    if (i !== j) {
                        if (options[i] === options[j]) {
                            matchFound = true;
                            toastr.error(
                                "Opps!",
                                `options${i + 1} and options${j + 1} are same`
                            );
                            break;
                        }
                    }
                }
                if (matchFound) break;
            }
            if (!matchFound) {
                this.setState({
                    validate: true
                });
                toastr.success("Success!", "Validation Successful.");
            }
        } else {
            toastr.error("Opps!", "Answer doesn't match with options");
        }
    };

    checkInput = () => {
        console.log("checking input");
        this.setState({
            submitReady: true,
            preview: false
        });
        // this.submitReady = true;
        // this.preview = false;
    };

    openModal = () => {
        console.log("preview clicked");
        this.setState({
            preview: true
        });
        // this.preview = true;
    };
    closeModal = () => {
        this.setState({
            validate: false,
            preview: false,
            submitReady: false
        });
        // this.preview = false;
    };

    triggerChange = (event, data) => {
        // console.log("triggered");
        this.setState({
            submitReady: false,
            validate: false,
            preview: false
        });
        // this.preview = false;
    };

    fetchSelectedEntries = async () => {
        const { auth } = this.props;
        console.log("auth ", auth.email);
        console.log("fetch entries", this.state.showEntryCategory);
        let inputs = [];
        let eachEntry = {};

        if (this.state.showEntryCategory) {
            try {
                this.setState({
                    loading: true
                });
                let query = await firebase
                    .firestore()
                    .collection(this.state.showEntryCategory)
                    .where("data.author", "==", auth.email)
                    .limit(20);
                let documentSnapshot = await query.get();
                for (let i = 0; i < documentSnapshot.docs.length; i++) {
                    eachEntry = documentSnapshot.docs[i].data();
                    eachEntry.id = documentSnapshot.docs[i].id;
                    inputs.push(eachEntry);
                }
                this.setState({
                    fetchEntries: inputs,
                    alreadyFetchd: true
                });
                this.setState({
                    loading: false
                });
            } catch (error) {
                // dispatch(asyncActionError());
                console.log("error ", error);
            }
        } else {
            toastr.error("Opps!", "It seems you did not select category");
        }
    };

    handleSelectShowEntry = (event, data) => {
        this.setState({
            showEntryCategory: data.value
        });
    };

    handleChangeFetchCategory = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.category = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchCategoryDiv = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.categoryDiv = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchCategorySubDiv = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.categorySubDiv = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchQuestion = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.question = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchOption1 = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.option1 = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchOption2 = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.option2 = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchOption3 = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.option3 = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchOption4 = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.option4 = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchAnswer = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.answer = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangeFetchRefs = (event, data) => {
        let entries = this.state.fetchEntries;
        entries[this.state.selectedIndex].data.ref = data;
        this.setState({
            fetchEntries: entries,
            submitReady: false,
            validate: false,
            preview: false
        });
    };

    handleChangePrevious = () => {
        console.log(this.state.selectedIndex);
        if (this.state.selectedIndex > 0) {
            this.setState({
                selectedIndex: this.state.selectedIndex - 1
            });
        }
    };

    handleChangeNext = () => {
        console.log(this.state.selectedIndex);
        if (this.state.selectedIndex < this.state.fetchEntries.length - 1) {
            this.setState({
                selectedIndex: this.state.selectedIndex + 1
            });
        }
    };

    handleEditFetchedEntries = async (event, values) => {
        console.log(
            "values id",
            this.state.fetchEntries[this.state.selectedIndex].id
        );

        this.props.change(
            "id",
            this.state.fetchEntries[this.state.selectedIndex].id
        );
        this.props.change(
            "category",
            this.state.fetchEntries[this.state.selectedIndex].data.category
        );
        this.props.change(
            "categoryDiv",
            this.state.fetchEntries[this.state.selectedIndex].data.categoryDiv
        );
        this.props.change(
            "categorySubDiv",
            this.state.fetchEntries[this.state.selectedIndex].data
                .categorySubDiv
        );
        this.props.change(
            "question",
            this.state.fetchEntries[this.state.selectedIndex].data.question
        );
        this.props.change(
            "option1",
            this.state.fetchEntries[this.state.selectedIndex].data.option1
        );
        this.props.change(
            "option2",
            this.state.fetchEntries[this.state.selectedIndex].data.option2
        );
        this.props.change(
            "option3",
            this.state.fetchEntries[this.state.selectedIndex].data.option3
        );
        this.props.change(
            "option4",
            this.state.fetchEntries[this.state.selectedIndex].data.option4
        );
        this.props.change(
            "answer",
            this.state.fetchEntries[this.state.selectedIndex].data.answer
        );
        this.props.change(
            "ref",
            this.state.fetchEntries[this.state.selectedIndex].data.ref
        );
    };

    render() {
        const {
            // incrementCounter,
            // decrementCounter,
            // data,
            // openModal,
            id,
            categoryName,
            categoryDiv,
            categorySubDivision,
            question,
            option1,
            option2,
            option3,
            option4,
            answer,
            reference,
            invalid,
            submitting,
            pristine
        } = this.props;
        return (
            <div>
                <div>
                    <h1>Data Entry</h1>
                    <Grid>
                        <Grid.Column mobile={16} tablet={16} computer={10}>
                            <Segment>
                                <Form
                                    onSubmit={this.props.handleSubmit(
                                        this.onFormSubmit
                                    )}
                                >
                                    <Header
                                        sub
                                        color="teal"
                                        content="Category Name"
                                    />
                                    <Field
                                        name="category"
                                        type="text"
                                        component={SelectInput}
                                        options={category}
                                        placeholder="Please enter subject name"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchCategory
                                                : this.triggerChange
                                        }
                                    />

                                    {categoryName &&
                                        (categoryName ===
                                            "বাংলা ভাষা ও সাহিত্য" ||
                                            categoryName ===
                                                "English Language and Literature" ||
                                            categoryName === "গাণিতিক যুক্তি" ||
                                            categoryName === "সাধারণ বিজ্ঞান" ||
                                            categoryName ===
                                                "কম্পিউটার ও তথ্য প্রযুক্তি") && (
                                            <div
                                                style={{ marginBottom: "15px" }}
                                            >
                                                <Header
                                                    sub
                                                    color="teal"
                                                    content="Category division"
                                                />

                                                <Field
                                                    name="categoryDiv"
                                                    type="text"
                                                    component={SelectInput}
                                                    options={
                                                        categoryDivision[
                                                            categoryName
                                                        ]
                                                    }
                                                    placeholder="Please enter subject division"
                                                    onChange={
                                                        id
                                                            ? this
                                                                  .handleChangeFetchCategoryDiv
                                                            : this.triggerChange
                                                    }
                                                />
                                            </div>
                                        )}

                                    {categoryDiv &&
                                        (categoryName ===
                                            "বাংলা ভাষা ও সাহিত্য" ||
                                            categoryName ===
                                                "English Language and Literature") &&
                                        (categoryDiv === "ভাষা" ||
                                            categoryDiv === "সাহিত্য" ||
                                            categoryDiv === "Language" ||
                                            categoryDiv === "Literature") && (
                                            <div>
                                                <Header
                                                    sub
                                                    color="teal"
                                                    content="Category Sub-division"
                                                />

                                                <Field
                                                    name="categorySubDiv"
                                                    type="text"
                                                    component={SelectInput}
                                                    options={
                                                        subDivision[categoryDiv]
                                                    }
                                                    placeholder="Please enter subject division"
                                                    onChange={
                                                        id
                                                            ? this
                                                                  .handleChangeFetchCategorySubDiv
                                                            : this.triggerChange
                                                    }
                                                />
                                            </div>
                                        )}

                                    <Header
                                        sub
                                        color="teal"
                                        content="Question"
                                    />

                                    <Field
                                        name="question"
                                        type="text"
                                        component={CustomTextArea}
                                        placeholder="Please enter the question"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchQuestion
                                                : this.triggerChange
                                        }
                                    />

                                    <Header
                                        sub
                                        color="teal"
                                        content="Option 1"
                                    />

                                    <Field
                                        name="option1"
                                        type="text"
                                        component={TextInput}
                                        placeholder="Please enter first option"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchOption1
                                                : this.triggerChange
                                        }
                                    />

                                    <Header
                                        sub
                                        color="teal"
                                        content="Option 2"
                                    />

                                    <Field
                                        name="option2"
                                        type="text"
                                        component={TextInput}
                                        placeholder="Please enter second option"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchOption2
                                                : this.triggerChange
                                        }
                                    />

                                    <Header
                                        sub
                                        color="teal"
                                        content="Option 3"
                                    />

                                    <Field
                                        name="option3"
                                        type="text"
                                        component={TextInput}
                                        placeholder="Please enter third option"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchOption3
                                                : this.triggerChange
                                        }
                                    />

                                    <Header
                                        sub
                                        color="teal"
                                        content="Option 4"
                                    />

                                    <Field
                                        name="option4"
                                        type="text"
                                        component={TextInput}
                                        placeholder="Please enter forth option"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchOption4
                                                : this.triggerChange
                                        }
                                    />

                                    <Header sub color="teal" content="Answer" />

                                    <Field
                                        name="answer"
                                        type="text"
                                        component={TextInput}
                                        placeholder="Please provide an answer"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchAnswer
                                                : this.triggerChange
                                        }
                                    />

                                    <Header
                                        sub
                                        color="teal"
                                        content="Reference"
                                    />

                                    <Field
                                        name="ref"
                                        type="text"
                                        component={TextInput}
                                        placeholder="Please enter subject name"
                                        onChange={
                                            id
                                                ? this.handleChangeFetchRefs
                                                : this.triggerChange
                                        }
                                    />

                                    <Button
                                        disabled={
                                            invalid || submitting || pristine
                                        }
                                        onClick={this.qusValidate(
                                            option1,
                                            option2,
                                            option3,
                                            option4,
                                            answer
                                        )}
                                        secondary
                                        type="button"
                                    >
                                        Validate
                                    </Button>
                                    <Button
                                        disabled={!this.state.validate}
                                        onClick={this.openModal}
                                        primary
                                        type="button"
                                    >
                                        Preview
                                    </Button>

                                    <Button
                                        disabled={
                                            invalid ||
                                            submitting ||
                                            pristine ||
                                            !this.state.submitReady
                                        }
                                        positive
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        onClick={() => this.props.reset()}
                                        negative
                                        type="button"
                                        style={{
                                            float: "right"
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Form>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={6}>
                            <Button primary onClick={this.showData}>
                                Show Data
                            </Button>
                            <Button primary onClick={this.randomReset}>
                                Reset Random
                            </Button>
                            <Button primary onClick={this.createTestDocuments}>
                                Create Document
                            </Button>
                            <h1>Show Entry</h1>
                            <Dropdown
                                placeholder="Please select your category"
                                fluid
                                search
                                selection
                                options={category}
                                value={this.state.showEntryCategory}
                                onChange={this.handleSelectShowEntry}
                                clearable
                            />
                            <Button
                                primary
                                loading={this.state.loading}
                                onClick={this.fetchSelectedEntries}
                                style={{ marginTop: "20px" }}
                            >
                                Fetch Last 20 Entry
                            </Button>

                            {this.state.alreadyFetchd && (
                                <Card style={{ width: "100%" }}>
                                    <Card.Content
                                        header={`# ${this.state.selectedIndex +
                                            1}`}
                                    />
                                    <Card.Content
                                        description={
                                            "Category: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.category
                                        }
                                    />
                                    {this.state.fetchEntries[
                                        this.state.selectedIndex
                                    ].data.categoryDiv && (
                                        <Card.Content
                                            description={
                                                "Category Div: " +
                                                this.state.fetchEntries[
                                                    this.state.selectedIndex
                                                ].data.categoryDiv
                                            }
                                        />
                                    )}
                                    {this.state.fetchEntries[
                                        this.state.selectedIndex
                                    ].data.categorySubDiv && (
                                        <Card.Content
                                            description={
                                                "Category Sub Div: " +
                                                this.state.fetchEntries[
                                                    this.state.selectedIndex
                                                ].data.categorySubDiv
                                            }
                                        />
                                    )}

                                    <Card.Content
                                        description={
                                            "Question: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.question
                                        }
                                    />

                                    <Card.Content
                                        description={
                                            "Option1: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.option1
                                        }
                                    />

                                    <Card.Content
                                        description={
                                            "Option2: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.option2
                                        }
                                    />

                                    <Card.Content
                                        description={
                                            "Option3: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.option3
                                        }
                                    />

                                    <Card.Content
                                        description={
                                            "Option4: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.option4
                                        }
                                    />

                                    <Card.Content
                                        description={
                                            "answer: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.answer
                                        }
                                    />

                                    <Card.Content
                                        description={
                                            "Ref: " +
                                            this.state.fetchEntries[
                                                this.state.selectedIndex
                                            ].data.ref
                                        }
                                    />

                                    <Card.Content extra>
                                        <Button
                                            positive
                                            onClick={
                                                this.handleEditFetchedEntries
                                            }
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            secondary
                                            onClick={this.handleChangePrevious}
                                            disabled={
                                                this.state.selectedIndex === 0
                                            }
                                        >
                                            Previous
                                        </Button>
                                        <Button
                                            secondary
                                            onClick={this.handleChangeNext}
                                            disabled={
                                                this.state.selectedIndex ===
                                                this.state.fetchEntries.length -
                                                    1
                                            }
                                        >
                                            Next
                                        </Button>
                                    </Card.Content>
                                </Card>
                            )}
                        </Grid.Column>
                    </Grid>
                </div>

                {this.state.preview && (
                    <PreviewModal
                        categoryName={categoryName}
                        categoryDiv={categoryDiv}
                        subDivision={categorySubDivision}
                        question={question}
                        option1={option1}
                        option2={option2}
                        option3={option3}
                        option4={option4}
                        open={this.state.preview}
                        answer={answer}
                        reference={reference}
                        checkInput={this.checkInput}
                        close={this.closeModal}
                    />
                )}
            </div>
        );
    }
}

export default connect(
    mapState,
    actions
)(
    reduxForm({ form: "inputForm", enableReinitialize: true, validate })(
        ExperiemntPage
    )
);
